import AlertPanel from './AlertPanel';
export default AlertPanel;